import { render } from "./Seo.vue?vue&type=template&id=cd61e014"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"

import "./Seo.vue?vue&type=style&index=0&id=cd61e014&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__